export default function Blank() {
  return null;
}
